import React, { useMemo, useCallback } from "react";
import {
  DataGrid,
  gridPageCountSelector,
  gridPageSelector,
  gridPageSizeSelector,
  useGridApiContext,
  useGridSelector,
  gridPaginationRowCountSelector,
} from "@mui/x-data-grid";
import Pagination from "@mui/material/Pagination";
import Select from "react-select";

const pageSizeOption = [
  {
    value: "5",
    label: "5",
  },
  {
    value: "10",
    label: "10",
  },
  {
    value: "15",
    label: "15",
  },
  {
    value: "20",
    label: "20",
  },
  {
    value: "50",
    label: "50",
  },
  {
    value: "100",
    label: "100",
  },
];

const DEFAULT_PAGE_SIZE_OPTIONS = [5, 20, 30];

const EMPTY_CUSTOM_STYLES = Object.freeze({});

const BASE_STYLES = {
  fontFamily: "Sarabun",
  fontSize: "17px",
  ".MuiDataGrid-columnHeaderTitle": {
    fontFamily: "Sarabun",
    fontSize: "17px",
  },
  ".MuiDataGrid-cell": {
    display: "flex",
    alignItems: "center",
    paddingTop: "5px",
    paddingBottom: "5px",
  },
};

const SLOT_PROPS = {
  pagination: { labelRowsPerPage: "จำนวนรายการต่อหน้า" },
};

function CustomPagination() {
  const apiRef = useGridApiContext();
  const page = useGridSelector(apiRef, gridPageSelector);
  const pageCount = useGridSelector(apiRef, gridPageCountSelector);
  const pageSize = useGridSelector(apiRef, gridPageSizeSelector);
  const rowCount = useGridSelector(apiRef, gridPaginationRowCountSelector);

  const firstRowIndex = rowCount === 0 ? 0 : page * pageSize;
  const lastRowIndex =
    rowCount === 0 ? 0 : Math.min((page + 1) * pageSize, rowCount);

  return (
    <div className="flex  px-4 items-center">
      <div className="text-[#4C4E64]/[0.67] font-normal mr-4">
        จำนวนรายการต่อหน้า
      </div>
      <div className="mr-4">
        <Select
          menuPlacement="top"
          name="pageSize"
          onChange={(selectedOption) => {
            apiRef.current.setPaginationModel({ page: 0, pageSize: Number(selectedOption.value) });
          }}
          className={`w-100 `}
          options={pageSizeOption}
          placeholder=""
          value={pageSizeOption.find((item) => item.value == pageSize)}
          styles={{
            control: (baseStyles, state) => ({
              ...baseStyles,
              border: 0,
            }),
            indicatorSeparator: (baseStyles, state) => ({
              ...baseStyles,
              display: "none",
            }),
          }}
        />
      </div>

      <div className="text-[#4C4E64]/[0.67] font-normal mr-4">
        {firstRowIndex + (rowCount === 0 ? 0 : 1)}-{lastRowIndex} of {rowCount}
      </div>

      <Pagination
        sx={(theme) => ({
          padding: theme.spacing(1.5, 0),
          ".MuiPaginationItem-root.Mui-selected": {
            backgroundColor: "#2DC76D",
            color: "#FFF",
          },
        })}
        count={pageCount}
        page={page + 1}
        onChange={(event, value) => apiRef.current.setPage(value - 1)}
      />
    </div>
  );
}

const SLOTS = {
  pagination: CustomPagination,
};

export const AllderTable = React.memo(function AllderTable({
  data,
  loading,
  columns,
  totalRows,
  paginationModel,
  setPaginationModel,
  handleSort,
  pageSizeOptions = DEFAULT_PAGE_SIZE_OPTIONS,
  customStyles = EMPTY_CUSTOM_STYLES,
  rowSelectionEnabled = true,
  ...props
}) {
  const styles = useMemo(
    () =>
      customStyles === EMPTY_CUSTOM_STYLES
        ? BASE_STYLES
        : { ...BASE_STYLES, ...customStyles },
    [customStyles]
  );

  const paginationProps = useMemo(
    () => ({
      paginationModel,
      onPaginationModelChange: setPaginationModel,
      pageSizeOptions,
      paginationMode: "server",
      rowCount: totalRows,
    }),
    [paginationModel, setPaginationModel, pageSizeOptions, totalRows]
  );

  const getRowHeight = useCallback(() => "auto", []);

  const getRowId = useCallback((row) => row.id, []);

  return (
    <DataGrid
      autoHeight
      loading={loading}
      getRowId={getRowId}
      getRowHeight={getRowHeight}
      rows={data}
      columns={columns}
      {...paginationProps}
      sortingMode="server"
      onSortModelChange={handleSort}
      checkboxSelection={rowSelectionEnabled}
      disableRowSelectionOnClick={rowSelectionEnabled}
      slotProps={SLOT_PROPS}
      sx={styles}
      slots={SLOTS}
      {...props}
    />
  );
});

AllderTable.displayName = "AllderTable";

export default AllderTable;
